<template>
    <div class="center_content wide padding">
    <div v-if="failure_reason == 'drive_too_far'">
        <h1 class="big">{{  $t('compare.bike-fail') }} ☹</h1>
        <p>
            {{  $t('compare.bike-fail.info') }}
        </p>
        <ul>
            <li>{{  $t('compare.bike-fail.suggestion1') }} </li>
            <li>{{  $t('compare.bike-fail.suggestion2') }} </li>
            <li>{{  $t('compare.bike-fail.suggestion3') }} </li>
    
        </ul>
        <hr class="spacer half" />
    </div>
    
    <div v-if="failure_reason == 'rides_only'">
        <h1 class="big">{{  $t('compare.rides-only') }}</h1>
        <p>
            {{  $t('compare.rides-only.info') }}
        </p>
        <hr class="spacer half" />
    </div>
    
    </div>
</template>

<script>


export default {
    mixins: [ ],

    components: {
         
    },
    data: function(){
        return {

        }
    },
    props: {
        commutes : {
            type: Array,
            default : function(){
                return []
            }
        }
            
    },
    watch : {
    },
    
    computed: {
        failure_reason : function(){
            let ride_count = 0
            let drive_count = 0
            for(let k in this.commutes){
                if(['car', 'motorcycle'].includes(this.commutes[k].data.vehicle.vehicle)){
                    drive_count++
                }
                if(['bicycle', 'e-bicycle'].includes(this.commutes[k].data.vehicle.vehicle)){
                    ride_count++
                }
            }
            
            if(ride_count > 0 && drive_count == 0){
                return "rides_only"
            }
            if(drive_count > 0 && ride_count == 0){
                return "drive_too_far"
            }
            return "other"
        }
    },
    methods: {
    }
    

}
    

</script>

<style scoped>
ul {
    text-align: left;
}
li {
    list-style: outside;
}
</style>